import { api } from '../../../shared/api/client';

export interface ConnectFacebookResponse {
  success: boolean;
  account?: any;
  message?: string;
  requiresPageSelection?: boolean;
  pages?: Array<{
    id: string;
    name: string;
    hasInstagram: boolean;
    instagramId?: string;
  }>;
  currentInstagramId?: string;
}

/**
 * Подключает Facebook к аккаунту.
 * Идёт через api-клиент (пользовательский JWT) — роут /facebook/* защищён,
 * анонимный ключ давал 401.
 */
export async function connectFacebook(
  accountId: string,
  facebookAccessToken: string
): Promise<ConnectFacebookResponse> {
  return api.post<ConnectFacebookResponse>('/facebook/connect', {
    accountId,
    facebookAccessToken,
  });
}

/**
 * Подключает конкретную Facebook Page к аккаунту
 */
export async function connectFacebookPage(
  accountId: string,
  pageId: string,
  facebookAccessToken: string
): Promise<ConnectFacebookResponse> {
  return api.post<ConnectFacebookResponse>('/facebook/connect-page', {
    accountId,
    pageId,
    facebookAccessToken,
  });
}

/**
 * Отключает Facebook от аккаунта
 */
export async function disconnectFacebook(accountId: string): Promise<void> {
  await api.post<{ success: boolean }>('/facebook/disconnect', { accountId });
}
